module.exports = __webpack_public_path__ + "img/section3_pic1@2x.84f97eb4.png";